import { createCarousel } from "@/ui/carousel/carousel";
import { createContentSection } from "../content-section/content-section";
import { createYoutubeContent } from "../youtube-content/youtube-content";
import "./section-video-reviews.css";

export const createSectionVideoReviews = () => {
  const container = document.querySelector<HTMLElement>(
    ".carousel.video-reviews",
  );

  if (container !== null) {
    createCarousel(container);
  }

  createContentSection();
  createYoutubeContent();
};
